module.exports = __webpack_public_path__ + "img/greek-flag.835123c9.svg";